import { IntlTFunc } from 'next-intl';

import { SimpleProductFragment, ProductStockStatus } from '@/fo/api/magento';

import { utilMapSimpleProductData } from '../lib/utilMapSimpleProductData';
import { ConfigurableVariants, ProductsMindbox } from '../types';

export const configurableVariantsMapper = (
  configurableVariants: ConfigurableVariants,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox,
  options?: { preselectFirstInStock?: boolean }
) => {
  const preselect = options?.preselectFirstInStock ?? true;
  let selected = false;

  return configurableVariants
    .filter(
      (v) => !!v && !!v.product && !!v.attributes && v.attributes.length > 0
    )
    .map((variant) => {
      const product = variant?.product as SimpleProductFragment;
      const inStock = product?.stockStatus === ProductStockStatus.InStock;
      const isSelected = preselect ? !selected && inStock : false;

      if (isSelected) selected = true;

      return {
        sku: product?.sku ?? '',
        label: variant?.attributes?.[0]?.label ?? '',
        stockStatus: product?.stockStatus ?? null,
        isSelected,
        product: utilMapSimpleProductData(product, t, mindboxProducts)
      };
    });
};
